import {Toaster} from "@/components/ui/toaster";
import {Toaster as Sonner} from "@/components/ui/sonner";
import {TooltipProvider} from "@/components/ui/tooltip";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";
import {BrowserRouter, Routes, Route, Navigate, useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {ThemeProvider} from "@/components/theme-provider";
import Index from "./pages/Index";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Account from "./pages/Account";
import Leaderboard from "./pages/Leaderboard";
import NotFound from "./pages/NotFound";
import Polls from "./pages/Polls";
import PollDetail from "./pages/PollDetail";
import CategoryPage from "./pages/CategoryPage";
import SearchPage from "./pages/Search";
import Business from "./pages/Business";
import EmailConfirmation from "./pages/EmailConfirmation";
import Terms from "./pages/Terms";
import Insights from "./pages/Insights";
import Roadmap from "./pages/Roadmap";
import Whitepaper from "./pages/Whitepaper";
import Benefits from "./pages/Benefits";
import UserJourney from "./pages/UserJourney";
import Referral from "./pages/Referral";
import SupportedCountries from "./pages/SupportedCountries";
import Trends from "./pages/Trends";
import supabase from "./utils/supabaseClient.ts"
import ForgotPassword from "@/pages/ForgotPassword.tsx";
import Recover from "@/pages/Recover.tsx";
import {ScrollToTop} from "@/components/ScrollToTop.ts";
import XCallback from "@/pages/XCallback.tsx";
import {initGA} from "@/utils/analytics";
import AnalyticsHandler from "@/components/AnalyticsHandler.tsx";
import TelegramAnalytics from '@telegram-apps/analytics'
import Clans from "./pages/Clans";
import Leagues from "./pages/Leagues";
import {HelmetProvider} from "react-helmet-async";
import supabaseClient from "@/utils/supabaseClient.ts";
import WebApp from '@twa-dev/sdk';
import {AuthProvider, useAuth} from "@/contexts/AuthContext.tsx";
import {LoginModalProvider} from "@/contexts/LoginModalContext.tsx";
import LoginModal from "@/components/auth/LoginModal.tsx";

/*interface Session {
    access_token: string;
    refresh_token: string;
    user: {
        id: string;
        email?: string | null;
        aud: string;
        role?: string;
    };
}*/

const queryClient = new QueryClient();

const App = () => {

    /*const [session, setSession] = useState<Session | null>(() => {
        const cachedSession = localStorage.getItem('session');
        return cachedSession ? JSON.parse(cachedSession) : null;
    });*/

    const [telegramUser, setTelegramUser] = useState(null);

    useEffect(() => {
        if (!WebApp.initDataUnsafe?.user) {
            // console.log('Telegram WebApp üzerinden gelen kullanıcı bilgisi bulunamadı.');
            return;
        }

        const user = WebApp.initDataUnsafe.user;
        // console.log('Telegram kullanıcısı:', user);
        setTelegramUser(user);
    }, []);

    useEffect(() => {
        initGA();
        TelegramAnalytics.init({
            token: 'eyJhcHBfbmFtZSI6ImJsYW5rcG9sbF9hbmFseXRpY3NfaWRlbnRpZmllciIsImFwcF91cmwiOiJodHRwczovL3QubWUvYmxhbmtwb2xsQm90L2JsYW5rcG9sbCIsImFwcF9kb21haW4iOiJodHRwczovL2JsYW5rcG9sbC5jb20ifQ==!/2ak/Ej8loHHzVrGh2O31kddZwIV1YBt9vD36yY5Y00=',
            appName: 'blankpoll_analytics_identifier',
        });
    }, []);

    /* useEffect(() => {
         supabase.auth.getSession().then(({data: {session}}) => {

             setSession(session);
         });

         const {data: authListener} = supabase.auth.onAuthStateChange((_event, session) => {
             setSession(session);
         });

         return () => {
             authListener.subscription.unsubscribe();
         };
     }, []);*/

    /*useEffect(() => {
        if (session) {
            localStorage.setItem("session", JSON.stringify(session));
        } else {
            localStorage.removeItem("session");
        }
    }, [session]);*/
    const PublicRoute = ({children}: { children: JSX.Element }) => {
        const {user, loading} = useAuth();

        if (loading) return <div>Loading...</div>;

        return !user ? children : <Navigate to="/account" replace/>;
    };

    /*const ProtectedRoute = ({children}: { children: JSX.Element }) => {
        if (!session) {
            return <Navigate to="/login" replace/>;
        }
        return children;
    };*/

    const ProtectedRoute = ({children}: { children: JSX.Element }) => {
        const {user, loading} = useAuth();

        if (loading) return <div>Loading...</div>;

        return user ? children : <Navigate to="/login" replace/>;
    };

    return (
        <HelmetProvider>
            <QueryClientProvider client={queryClient}>
                <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
                    <TooltipProvider>
                        <Toaster/>
                        <Sonner/>

                        <AuthProvider>
                            <LoginModalProvider>
                                <BrowserRouter>
                                    <AnalyticsHandler/>
                                    <ScrollToTop/>
                                    <Routes>
                                        <Route path="/" element={<Index/>}/>
                                        <Route path="/login" element={
                                            <PublicRoute>
                                                <Login/>
                                            </PublicRoute>
                                        }
                                        />
                                        <Route
                                            path="/signup"
                                            element={
                                                <PublicRoute>
                                                    <Signup/>
                                                </PublicRoute>
                                            }
                                        />
                                        <Route
                                            path="/forgot-password"
                                            element={
                                                <PublicRoute>
                                                    <ForgotPassword/>
                                                </PublicRoute>
                                            }
                                        />
                                        <Route
                                            path="/recover"
                                            element={
                                                <PublicRoute>
                                                    <Recover/>
                                                </PublicRoute>
                                            }
                                        />
                                        <Route
                                            path="/x-callback"
                                            element={
                                                <ProtectedRoute>
                                                    <XCallback/>
                                                </ProtectedRoute>
                                            }
                                        />
                                        <Route
                                            path="/account"
                                            element={
                                                <ProtectedRoute>
                                                    <Account/>
                                                </ProtectedRoute>
                                            }
                                        />
                                        {/*<Route path="/login" element={!session ? <Login/> : <Navigate to={"/account"}/>}/>*/}
                                        {/*<Route path="/signup" element={!session ? <Signup/> : <Navigate to={"/account"}/>}/>*/}
                                        {/*<Route path="/forgot-password"
                                           element={!session ? <ForgotPassword/> : <Navigate to={"/account"}/>}/>*/}
                                        {/*<Route path="/recover"
                                           element={!session ? <Recover/> : <Navigate to={"/account"}/>}/>*/}
                                        {/*<Route path="/x-callback"
                                           element={session ? <XCallback/> : <Navigate to={"/login"}/>}/>*/}
                                        <Route path="/search" element={<SearchPage/>}/>
                                        <Route path="/polls" element={<Polls/>}/>
                                        <Route path="/polls/:slug" element={<PollDetail/>}/>
                                        <Route path="/categories/:category" element={<CategoryPage/>}/>
                                        <Route path="/leaderboard" element={<Leaderboard/>}/>
                                        <Route path="/benefits" element={<Benefits/>}/>
                                        <Route path="/clans" element={<Clans/>}/>
                                        <Route path="/leagues" element={<Leagues/>}/>
                                        <Route path="/business" element={<Business/>}/>
                                        <Route path="/insights" element={<Insights/>}/>
                                        <Route path="/trends" element={<Trends/>}/>
                                        <Route path="/terms" element={<Terms/>}/>
                                        <Route path="/roadmap" element={<Roadmap/>}/>
                                        <Route path="/whitepaper" element={<Whitepaper/>}/>
                                        <Route path="/user-journey" element={<UserJourney/>}/>
                                        <Route path="/referral" element={<Referral/>}/>
                                        <Route path="/supported-countries" element={<SupportedCountries/>}/>
                                        <Route path="/email-confirmation" element={<EmailConfirmation/>}/>
                                        {/*<Route
                                        path="/account"
                                        element={
                                            <ProtectedRoute>
                                                <Account/>
                                            </ProtectedRoute>
                                        }
                                    />*/}
                                        <Route path="*" element={<NotFound/>}/>
                                    </Routes>
                                    <LoginModal />
                                </BrowserRouter>
                            </LoginModalProvider>
                        </AuthProvider>

                    </TooltipProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </HelmetProvider>
    );
};

export default App;
